// packages/ui/src/components/settings/ChannelSettings.tsx
// Toggle channels enabled/disabled

export interface Channel {
  id: string
  name: string
  enabled: boolean
}

interface ChannelSettingsProps {
  channels: Channel[]
  onUpdate: (type: 'channel', payload: { id: string; enabled: boolean }) => void
}

export function ChannelSettings({ channels, onUpdate }: ChannelSettingsProps) {
  return (
    <div data-testid="settings-channels" className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-200 mb-3">Channels</h2>
      <p className="text-sm text-gray-400 mb-4">
        Enable or disable notification and input channels.
      </p>
      <div className="space-y-2">
        {channels.map((channel) => (
          <label
            key={channel.id}
            className="flex items-center justify-between p-3 rounded-lg bg-gray-800/50 hover:bg-gray-800 transition-colors cursor-pointer"
          >
            <span className="text-sm text-gray-200">{channel.name}</span>
            <input
              type="checkbox"
              data-testid={`channel-toggle-${channel.id}`}
              checked={channel.enabled}
              onChange={() =>
                onUpdate('channel', { id: channel.id, enabled: !channel.enabled })
              }
              className="w-4 h-4 rounded border-gray-600 text-blue-500 focus:ring-blue-500 focus:ring-offset-gray-900"
            />
          </label>
        ))}
        {channels.length === 0 && (
          <p className="text-sm text-gray-500">No channels configured.</p>
        )}
      </div>
    </div>
  )
}
